import { axios } from '@/services/axios';

const getPermissionsList = async (id) => {
    const res = await axios.get('/permissions/' + id);
    return res.data;
};

export default getPermissionsList;
